import { Field, FieldProps, FormikProps } from 'formik';
import React, { useState } from 'react';

import { FileInput, FileInputProps } from '@blueprintjs/core';

import { FormGroup } from '../form/Form';

export interface IFormikFileInputControlProps {
  name: string;
  label: string;
  placeholder?: string;
  helpText?: string;
  disabled?: boolean;
}

export const FormikFileInputControl = (
  props: IFormikFileInputControlProps & Omit<FileInputProps, 'id' | 'onInputChange' | 'text'>
) => {
  const { name, label, helpText, placeholder, disabled, ...fileInputProps } = props;

  const handleFileChange = (event: React.FormEvent<HTMLInputElement>, form: FormikProps<unknown>) => {
    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    setFileInputText(file?.name);
    form.setFieldValue(name, file);
    form.setFieldTouched(name, true);
  };

  const [fileInputText, setFileInputText] = useState(placeholder);

  return (
    <FormGroup label={label} labelFor={name} helperText={helpText}>
      <Field name={name}>
        {(fieldProps: FieldProps) => (
          <FileInput
            {...fileInputProps}
            id={name}
            disabled={disabled}
            text={fileInputText}
            onInputChange={event => handleFileChange(event, fieldProps.form)}
          />
        )}
      </Field>
    </FormGroup>
  );
};
